import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

export const FEATURE_NAME = 'features';

export const selectExamples = createFeatureSelector< FeaturesState>(
  FEATURE_NAME
);

export const reducers: ActionReducerMap<FeaturesState> = { };

export interface State {
  features: FeaturesState;
}

export interface FeaturesState { }
